import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import axios from "axios";
import "@/index.css";
import App from "@/App";

// 🔒 Security (Feb 07, 2026): Route ALL auth through HttpOnly cookies.
// Setting withCredentials globally ensures every axios request automatically
// carries the httpOnly `access_token` cookie set by the backend at login.
// This deprecates the previous localStorage-based JWT flow which was
// vulnerable to any XSS exfiltration.
axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
